import React from 'react'
import { range } from 'ramda'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Skeleton from '@mui/material/Skeleton'

function Loader () {
  const items = range(0, 5)
  return <>
    {items.map((index) => (
      <TableRow
        hover={true}
        key={index}
      >
        <TableCell>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell width={50}>
          <Skeleton width={40} height={40} variant="circular" />
        </TableCell>
      </TableRow>
    ))}
  </>
}

export default Loader
